// Load Cloudinary widget if not already loaded
export const loadCloudinaryWidget = () => {
    return new Promise((resolve) => {
      if (window.cloudinary) {
        resolve(window.cloudinary);
      } else {
        const script = document.createElement('script');
        script.src = 'https://widget.cloudinary.com/v2.0/global/all.js';
        script.onload = () => resolve(window.cloudinary);
        document.body.appendChild(script);
      }
    });
  };
  
  // Service to upload image using Cloudinary Upload Widget
  export const uploadImageToCloudinary = async () => {
    const cloudinary = await loadCloudinaryWidget();
  
    return new Promise((resolve, reject) => {
      const widget = cloudinary.createUploadWidget(
        {
          cloudName: process.env.REACT_APP_CLOUDINARY_CLOUD_NAME, // Access cloud name from .env
          uploadPreset: process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET, // Use upload preset from .env
          folder: 'your-folder', // Optional: Define folder for uploads
        },
        (error, result) => {
          if (result.event === 'success') {
            resolve(result.info.secure_url); // Return the uploaded image URL
          } else if (error) {
            reject(error); // Handle error
          }
        }
      );
      widget.open(); // Open the Cloudinary Upload Widget
    });
  };
  